var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
        return Reflect.metadata(k, v);
};
import { LitElement } from "lit";
import { property } from "lit/decorators/property.js";
export class ChMarkdownViewerLit extends LitElement {
    #value_accessor_storage;
    /**
     * Specifies the template result to render.
     */
    get value() { return this.#value_accessor_storage; }
    set value(value) { this.#value_accessor_storage = value; }
    // "Shadow DOM === false"
    createRenderRoot() {
        return this;
    }
    render() {
        return this.value;
    }
}
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Array)
], ChMarkdownViewerLit.prototype, "value", null);
customElements.define("ch-markdown-viewer-lit", ChMarkdownViewerLit);
